<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import severityEnum from '../enums/severity'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                internalMemberAuditForm: () => import('../forms/InternalMemberAuditForm'),
                fields: [
                    { type: 'autocomplete', text: 'Internal Member Audit', value: 'internalMemberAuditId', rules: [v => !!v || 'Internal Member Audit is required'], isRequired: true, form: () => import('./InternalMemberAuditForm'), apiMethod: 'InternalMemberAudits', claim: 'InternalMemberAudits' },
                    { type: 'textarea', text: 'Description', value: 'description', rules: [v => !!v || 'Description is required'], isRequired: true, maxLength: false },
                    { type: 'enum', text: 'Severity', value: 'severity', rules: [v => (v !== null && v !== '') || 'Severity is required'], isRequired: true, items: enumService.enumAsSelectList(severityEnum) },
                    { type: 'datetime', text: 'Raised At', value: 'raisedAt', rules: [v => !!v || 'Raised At is required'], isRequired: true },
                    { type: 'datetime', text: 'Rectify By', value: 'rectifyBy', rules: [v => !!v || 'Rectify By is required'], isRequired: true },
                    { type: 'datetime', text: 'Rectified On', value: 'rectifiedOn', rules: [] },
                    { type: 'textarea', text: 'Comments', value: 'comments', rules: [], maxLength: false },
                ],
                apiMethod: 'InternalCorrectiveActionRequests',
                formTitle: 'Internal Corrective Action Request',
            }
        },
    };
</script>
